import { useState, useEffect, useCallback } from "react";

export type observerType = {
  pageNo: number;
  listSize: number;
  loading: boolean;
  first: boolean;
};

const baseOption = {
  threshold: 0.5,
};

const useIntersect = (onIntersect: any, option: any) => {
  const [ref, setRef] = useState<any>(null);
  const checkIntersect = ([entry]: any, observer: any) => {
    if (entry.isIntersecting) {
      onIntersect(entry, observer);
    }
  };

  useEffect(() => {
    let observer: any;
    if (ref) {
      observer = new IntersectionObserver(checkIntersect, { ...baseOption });
      observer.observe(ref);
    }
    return () => observer && observer.disconnect();
  }, [ref, checkIntersect]);
  return [ref, setRef];
};

export default useIntersect;
